import { BoldChip, BoldChipColors } from 'components/BoldChip';
import { getTrans, TranslationKey } from 'modules/i18n';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';
import { GeneralStatus, StatusType } from '../types';

interface Props {
  status: StatusType;
  statusMap: Partial<
    Record<StatusType, { color: BoldChipColors; label: TranslationKey | '' }>
  >;
}

export const StatusBadge = ({ status, statusMap }: Props) => {
  const { color, label } = statusMap[status] || {
    color: 'warning',
    label: ''
  };

  const newStatusFlag = useFeatureToggle(FeatureFlag.NEW_WEEK_STATUSES);

  const isOpen = status === GeneralStatus.OPEN;
  const isClosed = status === GeneralStatus.CLOSED;

  let translatedLabel = label ? getTrans(label) : status;

  // temporary logic to replicate previous behaviour
  // yes, we didn't use translations :(
  if (isOpen && !newStatusFlag.isEnabled) {
    translatedLabel = 'Open';
  }
  if (isClosed) {
    translatedLabel = 'Closed';
  }

  return <BoldChip variant="soft" label={translatedLabel} color={color} />;
};
